import { createMongoAbility } from '@casl/ability'
import { abilitiesPlugin } from '@casl/vue'
import { generateUserAbilityRules } from './utils/permissionParser'
import { useCookie } from '@core/composable/useCookie'

/**
 * Enhanced CASL plugin with team-based permissions
 */
export default function (app) {
  // Get user data from cookies (minimal) and localStorage (full)
  const userData = useCookie('userData')
  
  let initialRules = []
  
  // Try to get ability rules from localStorage first
  try {
    const storedRules = localStorage.getItem('userAbilityRules')
    if (storedRules) {
      initialRules = JSON.parse(storedRules)
    }
  } catch (error) {
    console.warn('Failed to parse stored ability rules:', error)
  }
  
  // If no stored rules and we have user data, generate rules
  if (initialRules.length === 0 && userData.value) {
    try {
      // Get full user data from localStorage
      const fullUserData = localStorage.getItem('fullUserData')
      if (fullUserData) {
        const user = JSON.parse(fullUserData)
        initialRules = generateUserAbilityRules(user)
        
        // Store generated rules in localStorage for future use
        localStorage.setItem('userAbilityRules', JSON.stringify(initialRules))
      }
    } catch (error) {
      console.warn('Failed to generate abilities from user data:', error)
      initialRules = []
    }
  }
  
  const initialAbility = createMongoAbility(initialRules)

  app.use(abilitiesPlugin, initialAbility, {
    useGlobalProperties: true,
  })
  
  // Provide method to update abilities when user data changes
  app.provide('updateAbilities', (user) => {
    const newRules = generateUserAbilityRules(user)
    initialAbility.update(newRules)
    localStorage.setItem('userAbilityRules', JSON.stringify(newRules))
  })
}
